import { toast } from "sonner";

// Conferma di salvataggio uniforme per ogni bottone "Salva" del CRM (stato visivo via attributi, senza toccare il testo React).
const RX_TESTO = /^\s*salva(\s|$)/i;
const RX_ID = /(^|-)(save|salva)(-|$)/i;
const LABEL = { saving: "Salvataggio…", ok: "✓ Salvato", err: "Non salvato – riprova", clean: "Salvato" };
let pending = null;

const isSalva = (b) => b && !b.closest("[data-no-salva]") && (RX_TESTO.test(b.textContent || "") || RX_ID.test(b.getAttribute("data-testid") || ""));
const setStato = (b, s) => {
  if (!b) return;
  if (!s) { delete b.dataset.salva; b.removeAttribute("data-salva-label"); return; }
  b.dataset.salva = s;
  b.setAttribute("data-salva-label", LABEL[s]);
};

export const salvatoToast = () => toast.success("Salvato", { id: "salvato", duration: 3000, style: { background: "#059669", color: "#fff", border: "1px solid #047857" } });

function chiudi(p) {
  const { btn, ok, clone } = p;
  pending = null;
  if (!ok) { clone?.remove(); setStato(btn, "err"); return; }
  setTimeout(() => {
    const altri = (toast.getToasts?.() || []).some((t) => t.type === "success" && t.id !== "salvato" && !t.dismiss);
    if (!altri && !document.querySelector("[data-sonner-toast][data-type=success]")) salvatoToast();
  }, 400);
  window.dispatchEvent(new CustomEvent("crm:salvato", { detail: { barra: p.barra } }));
  if (btn.isConnected) {
    clone?.remove();
    setStato(btn, "ok");
    setTimeout(() => { if (btn.dataset.salva === "ok") setStato(btn, "clean"); }, 3000);
    return;
  }
  if (clone) {
    clone.querySelectorAll("button").forEach((b) => { if (isSalva(b)) setStato(b, "ok"); });
    document.body.appendChild(clone);
    setTimeout(() => clone.remove(), 1000);
  }
}

function fotografa(p) {
  const box = p.btn.closest(".fixed.inset-0");
  if (!box || !p.btn.isConnected) return;
  const c = box.cloneNode(true);
  c.removeAttribute("data-testid");
  c.querySelectorAll("[data-testid]").forEach((x) => x.removeAttribute("data-testid"));
  c.style.pointerEvents = "none";
  c.setAttribute("aria-hidden", "true");
  p.clone?.remove();
  p.clone = c;
}

export function installaSalvataggio(api) {
  document.addEventListener("click", (e) => {
    const b = e.target.closest?.("button");
    if (!isSalva(b)) return;
    if (b.dataset.salva === "saving" || b.dataset.salva === "clean") { e.preventDefault(); e.stopPropagation(); return; }
    setStato(b, null);
    pending = { btn: b, t: Date.now(), reqs: 0, ok: true, timer: null, clone: null,
                barra: document.body.classList.contains("has-unsaved-bar") || !!b.closest("[data-testid=unsaved-bar],[data-testid=modal-unsaved-bar]") };
  }, true);
  const libera = () => document.querySelectorAll("button[data-salva=clean]").forEach((b) => setStato(b, null));
  document.addEventListener("input", libera, true);
  document.addEventListener("pointerdown", (e) => {
    const t = e.target.closest?.("button,input,select,textarea,[role=button],[role=checkbox],[draggable=true]");
    if (t && t.dataset.salva !== "clean") libera();
  }, true);
  document.addEventListener("change", libera, true);

  api.interceptors.request.use((config) => {
    const m = (config.method || "get").toLowerCase();
    if (pending && m !== "get" && (pending.reqs > 0 || pending.timer || Date.now() - pending.t < 2500)) {
      config._salva = pending;
      clearTimeout(pending.timer); pending.timer = null;
      pending.reqs += 1;
      setStato(pending.btn, "saving");
    }
    return config;
  });
  const fine = (cfg, ok) => {
    const p = cfg?._salva;
    if (!p || p !== pending) return;
    p.reqs -= 1;
    if (!ok) p.ok = false; else fotografa(p);
    if (p.reqs <= 0) p.timer = setTimeout(() => chiudi(p), 180);
  };
  api.interceptors.response.use((r) => { fine(r.config, true); return r; }, (err) => { fine(err?.config, false); return Promise.reject(err); });
}
